import * as Service from '../catalog-services';

export default {
  // All Catalog
  /**
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllCategories({ commit }) {
    const response = await Service.getProductsCategories();
    commit('setBaseData', response);
    if (response.length > 0) {
      await commit('setCategory');
      await commit('setSubCategory');
      await commit('setMicroCategory');
    }
  },

  // Categories API
  /**
   *
   * @param dispatch
   * @param payload
   * @returns {Promise<AxiosResponse<T>>}
   */
  async createCategory({ dispatch }, payload) {
    const response = await Service.createCategory(payload);
    await dispatch('fetchAllCategories');

    return response;
  },

  /**
   *
   * @param dispatch
   * @param data
   * @param categoryId
   * @returns {Promise<void>}
   */
  async updateCategory({ dispatch }, { data, categoryId }) {
    await Service.updateCategory(data, categoryId);
    await dispatch('fetchAllCategories');
  },

  /**
   *
   * @param commit
   * @param categoryId
   * @returns {Promise<void>}
   */
  async deleteCategory({ dispatch }, categoryId) {
    await Service.deleteCategory(categoryId);
    await dispatch('fetchAllCategories');
  },

  // SubCategory API
  /**
   *
   * @param commit
   * @param form
   * @returns {Promise<AxiosResponse<T>>}
   */
  async createSubCategory({ dispatch }, { form }) {
    const response = await Service.createSubCategory(form);
    await dispatch('fetchAllCategories');
    return response;
  },

  /**
   *
   * @param commit
   * @param data
   * @param subCategoryId
   * @returns {Promise<void>}
   */
  async updateSubCategory({ dispatch }, { data, subCategoryId }) {
    await Service.updateSubCategory(data, subCategoryId);
    await dispatch('fetchAllCategories');
  },

  /**
   *
   * @param commit
   * @param subCategoryId
   * @param categoryId
   * @returns {Promise<void>}
   */
  async deleteSubCategory({ dispatch }, { subCategoryId }) {
    await Service.deleteSubCategory(subCategoryId);
    await dispatch('fetchAllCategories');
  },

  // MicroCategory
  /**
   *
   * @param commit
   * @param form
   * @param category
   * @returns {Promise<AxiosResponse<T>>}
   */
  async createMicroCategory({ dispatch }, { form }) {
    const response = await Service.createMicroCategory(form);
    await dispatch('fetchAllCategories');

    return response;
  },

  /**
   *
   * @param commit
   * @param data
   * @param category
   * @returns {Promise<void>}
   */
  async updateMicroCategory({ dispatch }, { data, microCategoryId }) {
    await Service.updateMicroCategory(data, microCategoryId);
    await dispatch('fetchAllCategories');
  },

  /**
   *
   * @param commit
   * @param subCategoryId
   * @param microCategoryId
   * @returns {Promise<void>}
   */
  async deleteMicroCategory({ dispatch }, { microCategoryId }) {
    await Service.deleteMicroCategory(microCategoryId);
    await dispatch('fetchAllCategories');
  },
};
